/** Accept either decimal separator; golf's +2.3 notation is stored as -2.3. */
export function parseHandicapIndex(value: string): number | null {
  const raw = value.trim();
  if (!/^[+-]?(?:\d+(?:[.,]\d)?|[.,]\d)$/.test(raw)) return null;
  const normalized = raw.replace(",", ".");
  const parsed = raw.startsWith("+")
    ? -Number(normalized.slice(1))
    : Number(normalized);
  return Number.isFinite(parsed) && parsed >= -10 && parsed <= 54
    ? parsed
    : null;
}
